<template>
  <div class="succesPayupay">
    <success-payu></success-payu>
  </div>
</template>

<script>
// @ is an alias to /src
import successPayu from "@/components/successPayu.vue";

export default {
  name: "successPU",

  components: {
    successPayu
  },
  created() {}
};
</script>


